<template>
    <DashboardContainer>
        <add-new-template/>
    </DashboardContainer>
</template>

<script>
import DashboardContainer from '../containers/DashboardContainer'
import addNewTemplate from '../components/templates/addNewTemplate'

export default {
    name: 'addTemplate',
    beforeCreate: function () {
        var auth = this.$storage.get('auth')
        if (!auth) {
            this.$router.push('/login')
        }else{
            if(!auth.token){
                this.$router.push('/login')
            }
        }
    },
    components: {
        DashboardContainer,
        addNewTemplate
    }
}
</script>